// url
export const BASE_URL = "https://api.vsojump.site";
export const HOME_URL = "/";
export const LOGIN_URL = "/login";
export const REGISTER_URL = "/register";
export const MANAGE_URL = "/manage";
export const MANAGE_LIST_URL = "/manage/list";
export const MANAGE_STAR_URL = "/manage/star";
export const MANAGE_TRASH_URL = "/manage/trash";
export const QUESTION_URL = "/question";
export const QUESTION_EDIT_URL = "/question/edit";
export const QUESTION_STAT_URL = "/question/stat";


// search
export const SEARCH_PARAM_KEY = "keyword";


// userinfo
export const USERNAME_KEY = "username";
export const PASSWORD_KEY = "password";
export const UID_KEY = 'uid';


// page
export const PAGE_PARM_KEY = "page";
export const PER_PAGE_SIZE_PARM_KEY = "perPageSize";
export const DEFAULT_PER_PAGE_SIZE = 10;



// token
export const TOKEN_KEY = "user_token";



// stat
export const STAT_PAGE_SIZE = 10 // 统计列表，默认的 pageSize
export const STAT_COLORS = ['#FF2D2D', '#BE77FF', '#2894FF', '#00EC00', '#EAC100', '#FF9D6F']


